import { render } from "./PatientDatatableActions.vue?vue&type=template&id=4f342601"
import script from "./PatientDatatableActions.vue?vue&type=script&lang=js"
export * from "./PatientDatatableActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__